import { Directive, HostListener, inject, input } from "@angular/core";
import { ToastService } from "../components/toast/toast.service";
import { fnCopyText } from "../helpers/copy-text";

@Directive({
    selector: "[appCopy]",
})
export class CopyDirective {
    readonly toastService = inject(ToastService);

    content = input.required<string>();

    @HostListener("click", ["$event"]) async handleCopyContent(ev: any) {
        ev.stopPropagation();
        ev.preventDefault();
        await fnCopyText(this.content());
        // navigator.clipboard.writeText(this.content());
        this.toastService.info("클립보드에 복사되었습니다.");
    }
}
